import React from 'react';

import { ButtonItem, MenuGroup, Section } from '@atlaskit/menu';
import { useIntl } from '@atlassian/jira-intl';

import messages from '../../../../common/messages';
import {
	type IncrementPlanningBoardViewProps,
	ExpandableState,
	ActionSubject,
	ToggleKey,
} from '../../../../common/types';
import { ViewSettingsToggle } from '../../../../common/ui/view-settings-toggle';
import { useViewSettings } from '../../../../controllers';

export const IncrementPlanningBoardMenu = ({
	viewAs,
	boardId,
	isSwimlanesEnabled = false,
	onHandleChange,
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	onSwimlaneExpandAll = () => {},
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	onSwimlaneCollapseAll = () => {},
}: IncrementPlanningBoardViewProps) => {
	const { formatMessage } = useIntl();
	const [state, actions] = useViewSettings();
	const { setShowUnscheduledColumn } = actions;

	return (
		<MenuGroup data-testId="software-view-settings.ui.view-settings-menu.menu-increment-planning-board">
			<Section>
				<ViewSettingsToggle
					testId="software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-unscheduled-column-toggle"
					title={formatMessage(messages.showUnscheduledWork)}
					onChange={() => {
						setShowUnscheduledColumn(boardId, !state.showUnscheduledColumn);
						onHandleChange(
							ActionSubject.TOGGLE,

							{
								key: ToggleKey.UNSCHEDULED_COLUMN_TOGGLE,
								state: !state.showUnscheduledColumn,
							},
						);
					}}
					isChecked={state.showUnscheduledColumn}
					viewAs={viewAs}
				/>
			</Section>
			{isSwimlanesEnabled && (
				<Section title={formatMessage(messages.swimlanes)} hasSeparator>
					<ButtonItem
						data-testid="software-view-settings.ui.view-settings-menu.views.increment-planning-board.expand-all"
						onClick={() => {
							onSwimlaneExpandAll();
							onHandleChange(ActionSubject.BUTTON, {
								key: ToggleKey.SWIMLANE_EXPAND_ALL,
								state: ExpandableState.EXPANDED,
							});
						}}
					>
						{formatMessage(messages.expandAll)}
					</ButtonItem>
					<ButtonItem
						data-testid="software-view-settings.ui.view-settings-menu.views.increment-planning-board.collapse-all"
						onClick={() => {
							onSwimlaneCollapseAll();
							onHandleChange(ActionSubject.BUTTON, {
								key: ToggleKey.SWIMLANE_COLLAPSE_ALL,
								state: ExpandableState.COLLAPSED,
							});
						}}
					>
						{formatMessage(messages.collapseAll)}
					</ButtonItem>
				</Section>
			)}
		</MenuGroup>
	);
};
